import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToggleService } from 'src/app/services/toggle.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { TermsConditionsPopoverComponent } from 'src/app/popovers/terms-conditions-popover/terms-conditions-popover.component';
import { PopoverController } from '@ionic/angular';
import { HelpPopoverComponent } from 'src/app/popovers/help-popover/help-popover.component';

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss'],
})
export class FooterMenuComponent implements OnInit {

  constructor(
    public router: Router,
    public toggleService: ToggleService,
    public unfocusService: UnfocusElementService,
    public popoverController: PopoverController
  ) { }

  ngOnInit() { }

  async goToTermsAndPolicies(ev) {
    this.unfocusService.unfocus(ev);
    const popover = await this.popoverController.create({
      component: TermsConditionsPopoverComponent,
      cssClass: 'terms-conditions-popover',
      event: event,
      showBackdrop: false,
    });
    return await popover.present();
  }

  async displayHelp(ev) {
    this.unfocusService.unfocus(ev);
    const popover = await this.popoverController.create({
      component: HelpPopoverComponent,
      cssClass: 'help-popover',
      event: event,
      showBackdrop: false,
    });
    return await popover.present();
  }

}
